import React from 'react';
import CodeComponent from './CodeComponent';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
var functions = require("./functions.js");

// ClientTable component
export default class HubInstructions extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            utc:new Date().getUTCDate
            }
      }
    // render
    render() {

        // get date for certs
        let yourDate = new Date()
        const offset = yourDate.getTimezoneOffset()
        yourDate = new Date(yourDate.getTime() - (offset*60*1000))
        let todayString=this.formatDate(yourDate);

        return (
            <div style={ this.props.style} className="scroll">
                <h2>
                    <a target='new' href='https://sites.google.com/wavedds.com/internal/documentation/hubs'>Hub WIKI</a>
                    &nbsp;
                    <a target="new" href='https://docs.google.com/document/d/1td85DZglLQ-b1mxXEIeRMca_NzY-Id2La2IkMLbki6Q/edit'>Hub Instructions</a>
                    &nbsp;
                    <a target="new" href="https://docs.google.com/document/d/1td85DZglLQ-b1mxXEIeRMca_NzY-Id2La2IkMLbki6Q/edit#heading=h.tuazez6z8ueb">w10</a>
                    &nbsp;
                    <a target="new" href="https://docs.google.com/document/d/1td85DZglLQ-b1mxXEIeRMca_NzY-Id2La2IkMLbki6Q/edit#heading=h.cmjz8jqpy76h">w100</a>
                </h2>
                <small>click on code to copy to clipboard</small>
                <Tabs defaultIndex={this.props.tabIndex} >
                    <TabList>
                        <Tab>Provision Hub</Tab>
                        <Tab>Send Data To Server</Tab>
                        <Tab>Test w10</Tab>
                        <Tab>Status of Services</Tab>
                        <Tab>w10 Networking</Tab>
                        <Tab>WIKI</Tab>
                        <Tab>W100/W1000 Instruction Book</Tab>
                        <Tab>W2000 Instruction Book</Tab>
                        <Tab>Cassia</Tab>
                        <Tab>CradlePoint</Tab>
                        <Tab>PEPWAVE</Tab>
                    </TabList>
                    <TabPanel >

                        <div>
                            <CodeComponent class="language-javascript" title="Create cert on WaveBeaconConfig" link="ssh://pi@WaveBeaconConfig" linkTitle="WaveBeaconConfig">
                                echo create provision file<br />
                                echo ---------------------------<br /> 
                                cd wave-v2/scripts<br />
                                ./hub-provision.py { this.props.hub.hostname }<br />
                                echo ---------------------------<br /> 
                                echo copy provision file to hub<br />
                                echo ---------------------------<br /> 
                                scp { this.props.hub.hostname }.{todayString}.waveconf.zip pi@{ this.props.hub.processor_ip_address}:/home/pi/wave-v2<br />
                                <br /> 
                            </CodeComponent>
                            <h4>WARNING: THIS WILL DELETE CURRENT CERTs</h4>
                            <CodeComponent 
                                    title="Delete old Certs, Run Provisioning Script, Reboot on Hub(ssh using IP address)" 
                                    link={"ssh://pi@"+this.props.hub.processor_ip_address }
                                    linkTitle="SSH into Hub with IP address"
                                    >
                                echo -----------------<br />
                                echo delete old certs<br />
                                echo -----------------<br />
                                ls /etc/wave/certs<br />
                                sudo rm /etc/wave/certs/*.*<br />
                                echo ---------------------------<br /> 
                                echo provision hub<br /> 
                                echo ---------------------------<br /> 
                                cd /home/pi/wave-v2/scripts/<br /> 
                                sudo ./boot-config.py<br /> 
                                <br /> 
                            </CodeComponent>
                            <CodeComponent
                                    title="Check certs on Hub, Expand File System (ssh using IP address)" 
                                    link={"ssh://pi@"+this.props.hub.processor_ip_address }
                                    linkTitle="SSH into Hub with IP address"
                            >
                                echo -----------------<br />
                                echo Display Certs<br />
                                echo -----------------<br />
                                ls /etc/wave/certs -l<br />
                                echo -----------------<br />
                                echo Expand File System<br />
                                echo -----------------<br />
                                sudo raspi-config --expand-rootfs<br />
                                echo -----------------<br />
                                echo reboot<br />
                                echo -----------------<br />
                                sudo reboot<br />
                            </CodeComponent>  
                        </div>
                    </TabPanel >
                    <TabPanel >

                        <div>
                            <CodeComponent 
                                title="Send Hub Data To Device App Server (run on bastion host)"
                                className="language-javascript">
                                {functions.updateHubCommand7(this.props.hub.hostname,this.props.hub.processor_user,this.props.hub.processor_app_port)}
                            </CodeComponent>
                            You can also run it from this screen in the "Update Device App with Hub Data" box.  The 3 buttons do the following:<br/>
                            Exec(Debug)-Copy the command into the clip board.  Then if ssh is a protocol that your browser recognizes, it will open an ssh terminal (to the bastion host) where you can paste the command in your clip board<br/>
                            Script-View the script commands<br/>
                            <CodeComponent title="SSH Error">
                                sudo date -s "{this.getUtcDate()}";sudo hwclock --systohc;
                            </CodeComponent>
                        </div>
                    </TabPanel >
                    <TabPanel >
                        <div>
                            <ul>
                                <li>Test Access to HMP App(above)</li>
                                <li>Add Client Wearables</li>
                                <li>Test Submersion</li>
                                <li>
                                    Test USB-C debug port (MAKE SURE CHARGER IS NOT PLUGGED IN) 
                                </li>
                                <li>Test Access to AWS Bastion Host Gateway (above)</li>
                                <li>
                                    Battey Charging
                                    <CodeComponent>
                                        sudo journalctl -u wave-supervisor -e
                                    </CodeComponent>
                                </li>
                                <li>
                                    Update Hub Script(above)
                                </li>
                                <li>
                                    Test soft shutdown
                                    <ul>
                                        <li>Press Button</li> 
                                        <li>The chase pattern should start, and the LEDs should turn off in about 10 seconds</li>
                                        <li>If not, force shutdown with a 10 seconds power button hold, but restart the system to ensure the 3 second shutdown works</li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                    </TabPanel >
                    <TabPanel >
                        <div>
                            <CodeComponent>sudo journalctl -u wave -e</CodeComponent>
                            <CodeComponent>sudo journalctl -u wave-supervisor -e</CodeComponent>
                            <CodeComponent>sudo journalctl -u wave-agent -e</CodeComponent>
                        </div>
                        <div>
                            <h3>check status of wave</h3>
                            <CodeComponent>sudo systemctl status wave</CodeComponent>
                        </div>
                        <div>
                            <CodeComponent title="All Status sevice">
                                service --status-all
                            </CodeComponent>
                        </div>
                        <div>
                            <CodeComponent title="Start Network Manager service">
                                sudo systemctl start NetworkManager.service
                            </CodeComponent>
                        </div>
                        <div>
                            <CodeComponent title="Start wave service">
                                sudo systemctl enable wave;
                                sudo systemctl start wave
                            </CodeComponent>
                        </div>
                        <div>
                            <CodeComponent title="view wave in fu mode">
                                sudo journalctl -fu wave
                            </CodeComponent>
                        </div>
                        <div>
                            <CodeComponent title="view dhcpcd.service">
                            sudo journalctl -u dhcpcd.service --since "2 days ago"
                            </CodeComponent>
                        </div>                        
                    </TabPanel >
                    <TabPanel >
                        <div>
                            <CodeComponent title="device status">
                                sudo nmcli dev status
                            </CodeComponent> 
                        </div>
                        <div>
                            <CodeComponent title="list networks">
                                nmcli dev wifi
                            </CodeComponent>
                        </div>
                        <div>
                            <CodeComponent title="Show connections saved">
                                sudo nmcli connection show
                            </CodeComponent>
                        </div>
                        <div>
                            <h3>connect to network</h3>
                            <CodeComponent>sudo nmcli dev wifi connect "Wave Demo" password "Lifesaver"</CodeComponent>
                            <CodeComponent>sudo nmcli dev wifi connect "Factory Underground " password "music1234"</CodeComponent>
                        </div>
                        <div>
                            <h3>delete connection</h3>
                            <CodeComponent>sudo nmcli connection delete "Factory Underground "</CodeComponent>
                            <CodeComponent>sudo nmcli connection delete "Wave Demo"</CodeComponent>
                        </div>
                    </TabPanel>                   
                    <TabPanel >
                        <div>
                            <h3><a  target='_blank' rel="noopener noreferrer" href='https://sites.google.com/wavedds.com/internal/documentation/hubs'>WIKI</a></h3>
                            <iframe title="w100w1000Instructions" style={{"width":"95%", "height":"800px"}} src='https://sites.google.com/wavedds.com/internal/documentation/hubs'></iframe>
                        </div>
                    </TabPanel>

                    <TabPanel >
                        <div>
                            <h3><a  target='_blank' rel="noopener noreferrer" href='https://docs.google.com/document/d/12hdaoDELVQqAmJiUkNikkjAwu5ZVGhOK0Hrz5RYT10A/edit#heading=h.axfpjhpmbek'>W100/W1000 Instruction Book</a></h3>
                            <iframe title="w100w1000Instructions" style={{"width":"95%", "height":"800px"}} src='https://docs.google.com/document/d/12hdaoDELVQqAmJiUkNikkjAwu5ZVGhOK0Hrz5RYT10A/edit#heading=h.axfpjhpmbek'></iframe>
                        </div>
                    </TabPanel>
                    <TabPanel >
                        <div>
                            <h3><a rel="noopener noreferrer" href='https://docs.google.com/presentation/d/1CG_IlSmo1mfMD-cCGGcdLD0EAhOXWgIiTIKkm4X_r4M/present?slide=id.p' target='_blank'>W2000 Instruction Book</a></h3>
                            <iframe title="w2000Instructions" style={{"width":"95%", "height":"800px"}} src='https://docs.google.com/presentation/d/1CG_IlSmo1mfMD-cCGGcdLD0EAhOXWgIiTIKkm4X_r4M/present?slide=id.p'></iframe>
                        </div>
                    </TabPanel>                    
                    <TabPanel >
                        <div>
                            <h3><a  target='_blank' rel="noopener noreferrer" href='https://docs.google.com/presentation/d/1d1KqHcPd-JjACAVrFqJ2U-dBq-DigPzkxbWHosTYJz0/edit#slide=id.p'>Cassia</a></h3>
                            <iframe title="cassia" style={{"width":"95%", "height":"800px"}} src='https://docs.google.com/presentation/d/1d1KqHcPd-JjACAVrFqJ2U-dBq-DigPzkxbWHosTYJz0/edit#slide=id.p'></iframe>
                        </div>
                    </TabPanel>
                    <TabPanel >
                        <div>
                            <h3><a  target='_blank' rel="noopener noreferrer" href='https://docs.google.com/presentation/d/1rzsQlN9qbqZdgRrJIrVhTsDjTMcmplRZXXKJNQjIRPY/edit#slide=id.p'>CradlePoint</a></h3>
                            <iframe title="cradlepoint" style={{"width":"95%", "height":"800px"}} src='https://docs.google.com/presentation/d/1rzsQlN9qbqZdgRrJIrVhTsDjTMcmplRZXXKJNQjIRPY/edit#slide=id.p'></iframe>
                        </div>
                    </TabPanel>
                    <TabPanel >
                        <div>
                            <h3><a  target='_blank' rel="noopener noreferrer" href='https://docs.google.com/document/d/12hdaoDELVQqAmJiUkNikkjAwu5ZVGhOK0Hrz5RYT10A/edit#heading=h.njemvgducipj'>Pepwave</a></h3>
                            <iframe title="pepwave" style={{"width":"95%", "height":"800px"}} src='https://docs.google.com/document/d/12hdaoDELVQqAmJiUkNikkjAwu5ZVGhOK0Hrz5RYT10A/edit#heading=h.njemvgducipj'></iframe>
                        </div>
                    </TabPanel>
                </Tabs>
            </div>

    );
    }     

    // ✅ Or create a reusable function
    padTo2Digits(num) {
        return num.toString().padStart(2, '0');
    }
  
    formatDate(date = new Date()) {
        return [
        this.padTo2Digits(date.getMonth() + 1),
        this.padTo2Digits(date.getDate()),
        date.getFullYear()-2000,
        ].join('');
    }

    getUtcDate(){
        let d=Date();
        try{
            d=new Date().toUTCString();
        } catch (e){
            console.log(e);
        }
        return d;
    }
}